import React from "react";
const AppSimpleText=({children})=>{
    return(
        <p className="font-normal text-[16px] leading-[28px]">{children}</p>
    )
}
export default AppSimpleText

